<template>
  <div>
    <v-card :loading="loading" outlined :style="$store.state.isMobile?'margin-bottom: 100px': ''">
      <v-toolbar class="pl-0" dense flat color="transparant">
        <v-subheader>{{$t("markers")}}</v-subheader>
        <v-spacer></v-spacer>
        <v-menu transition="scale-transition" origin="right top" style="z-index: 10" class="white" :close-on-content-click="false" bottom left>
          <template v-slot:activator="{ on }"> 
            <v-btn color="primary" icon v-on="on">
              <v-icon>fa-info-circle</v-icon>
            </v-btn>
          </template>
          <v-sheet flatwidth="600px" height="180px">
            <v-list dense>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="red">priority_high</v-icon>
                </v-list-item-icon>
                <v-list-item-content>{{$t('info_broken')}}</v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="orange">priority_high</v-icon>
                </v-list-item-icon>
                <v-list-item-content>{{$t('info_inProcess')}}</v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="success">check_circle</v-icon>
                </v-list-item-icon>
                <v-list-item-content>{{$t('info_approved')}}</v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="primary">priority_high</v-icon>
                </v-list-item-icon>
                <v-list-item-content>{{$t('info_new')}}</v-list-item-content>
              </v-list-item>
            </v-list>
          </v-sheet>
        </v-menu>
        <v-menu transition="scale-transition" origin="right top"
          offset-y
          style="z-index: 10"
          class="white"
          :close-on-content-click="false"
          bottom
          left
        >
          <template v-slot:activator="{ on }">
            <v-btn color="primary" icon v-on="on">
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-sheet flat width="200px" height="180px">
            <v-checkbox :hide-details="true" v-model="markerStatus" class="ml-2 mt-0" :value="4">
              <template slot="label">
                <v-icon color="primary">select_all</v-icon>
                {{$t('showAll')}}
              </template>
            </v-checkbox>
            <v-checkbox :hide-details="true" class="ml-2 mt-0" v-model="markerStatus" :value="0">
              <template slot="label">
                <v-icon color="red">priority_high</v-icon>
                {{$t('broken')}}
              </template>
            </v-checkbox>
            <v-checkbox :hide-details="true" class="ml-2 mt-0" v-model="markerStatus" :value="1">
              <template slot="label">
                <v-icon color="orange">priority_high</v-icon>
                {{$t('inProcess')}}
              </template>
            </v-checkbox>
            <v-checkbox :hide-details="true" class="ml-2 mt-0" v-model="markerStatus" :value="2">
              <template slot="label">
                <v-icon color="success">check_circle</v-icon>
                {{$t('approved')}}
              </template>
            </v-checkbox>
            <v-checkbox :hide-details="true" class="ml-2 mt-0" v-model="markerStatus" :value="3">
              <template slot="label">
                <v-icon color="primary">priority_high</v-icon>
                {{$t('new')}}
              </template>
            </v-checkbox>
          </v-sheet>
        </v-menu>
      </v-toolbar>
      <v-divider></v-divider>
 <v-text-field
          v-model="search"
          clearable
          flat
          dense
          solo
          hide-details
          prepend-inner-icon="search"
          :label="$t('search')"
          @click:clear="search = ''"
        ></v-text-field>
        <v-divider></v-divider>
      <template v-for="(marker,i) in filteredItems">
        <v-card
          v-bind:style="{ display: filterMarkers(marker) }"
          v-bind:class="{'active-row': (marker.draggable)}"
          @click="select(marker,i)"
          @dblclick="markerDetails(marker)"
          :key="i"
        >
          <v-card-title class="py-2">{{marker.number}} <template v-if="marker.label"> - {{marker.label}}</template> </v-card-title>

          <v-card-text class="py-0">
            <p class="caption mb-0">
              <template v-if="marker.date">{{$t('applicationDate')}} {{marker.date}}</template> 
              <br>
              <template
                  v-if="marker.installer"
                >{{$t('modifiedBy')}} {{marker.installer.firstname}} {{marker.installer.name}}
                {{marker.modifiedTs}}
                </template>
            </p>
            <p class="caption mb-0 text-truncate">{{marker.comments}}</p>
          </v-card-text>

          <v-card-actions>
            <template v-if="marker.qrId">
              <v-chip>
                <v-icon small class="mr-2" color="secondary">fa-qrcode</v-icon>
                <template v-if="$vuetify.breakpoint.mdAndUp">{{$t('linked')}}</template>
              </v-chip>
            </template>
            <template v-else>
              <v-chip>
                <v-icon small class="mr-2" color="error">fa-qrcode</v-icon>
                <template v-if="$vuetify.breakpoint.mdAndUp">{{$t('notLinked')}}</template>
              </v-chip>
            </template>

            <v-chip>
              <v-icon
                :color="marker.status == 0? 'red' :
                     marker.status == 1  ? 'orange':
                      marker.status == 2? 'success': 'primary'"
              >{{marker.status == 2 ? 'check_circle' : marker.status === 1 ? 'priority_high': 'priority_high'}}</v-icon>
              {{marker.status == 0 ? $t('broken') : marker.status == 2 ? $t('approved') : marker.status == 1 ? $t('inProcess') : $t('new') }}
            </v-chip>
            <v-spacer></v-spacer>
            <v-btn color="secondary" text @click="markerDetails(marker)">{{$t('open')}}</v-btn>
          </v-card-actions>
          <v-divider></v-divider>
        </v-card>
      </template>
      <v-card disabled v-if="$store.state.markersReadonly.length == 0" flat>
        <template v-if="$store.state.drawable">
          <p class="text-center pa-5 body-1 font-weight-light">
            <span>
              <v-icon color="primary">info</v-icon>
              {{$t('draw')}}
            </span>
          </p>
        </template>
        <div v-else v-ripple class="text-center pa-5 body-1 font-weight-light">
          <v-btn icon>
            <v-icon x-large color="primary">add_circle_outline</v-icon>
          </v-btn>
        </div>
      </v-card>
    </v-card>
  </div>
</template>


<script>
import uuid from "uuid";

export default {
  name: "markers",
  props: {
    blueprintFile: Object
  },
  components: {},
  data() {
    return {
      showDelete: false,
      selected: undefined,
      loading: false,
      markerStatus: [4],
      search: ''
    };
  },
  methods: {
    filterMarkers(marker) {
      return (marker.status == 1 &&
        // !this.requiredFields(marker) &&
        this.markerStatus.includes(1)) ||
        (marker.status == 0 &&
          // !this.requiredFields(marker) &&
          this.markerStatus.includes(0)) ||
        (marker.status == 3 &&
          // this.requiredFields(marker) &&
          this.markerStatus.includes(3)) ||
        (marker.status == 2 && this.markerStatus.includes(2)) ||
        this.markerStatus.includes(4)
        ? "inherit"
        : "none";
    },
    markerDetails(marker) {
      this.$emit("showMarkerDetails", marker);
    },
    select(item, i) {
      item.draggable = true;
      this.$store.commit("selectReadonly", item);
      this.$store.commit("select", item);
    },
    getMarkersLight() {
      this.$http
        .getMarkers(this.$route.params.id, true)
        .then(res => {
          this.loading = false;
          console.log("Loading store...");
          //adding the markerui fields here..
          res.data.forEach(element => {
            this.$store.commit("AddAndSetUIelementsReadonly", element);
          });
        })
        .catch(err => console.log(err));
    }
  },
  computed: {
    markers() {
      return this.$store.getters.markersReadonly;
    },
    filteredItems() {
      return this.$store.getters.markersReadonly.filter(item => {
        return item.label ? item.label
          .toLowerCase()
          .includes(this.search.toLowerCase()) : '' || item.number.toString()
          .toLowerCase()
          .includes(this.search.toLowerCase());
      });
    }
  },
  watch: {
    markers(after, before) {},
    markerStatus(n, o) {
      if (n.length > 1) {
        if (n[n.length - 1] === 4) {
          this.markerStatus = [4];
        } else {
          if (n.includes(4)) {
            this.markerStatus = this.markerStatus.filter(x => x != 4);
          }
        }
      }
    }
  },
  created() {
    // this.loading = true;
    // if (!this.$store.state.isOffline) {
    //   if (
    //     this.$store.state.markersReadonly.find(
    //       x => x.blueprintId == this.$route.params.id
    //     )
    //   ) {
    //     //if coming from marker details,
    //     if (this.$store.state.markersReadonly.length <= 1) {
    //       this.$store.state.markersReadonly = [];
    //       if (!this.$store.state.isOffline) {
    //         this.getMarkersLight();
    //       }
    //     } else {
    //       this.loading = false;
    //     }
    //   } else {
    //     //if blueprint has changed, empty list
    //     this.$store.state.markersReadonly = [];
    //     this.getMarkersLight();
    //   }
    // } else {
    //   this.loading = false;
    // }

    this.loading = true;
    this.$store.state.markersReadonly = [];
    this.getMarkersLight()
  }
};
</script>


<style>
a:not(.md-button):hover {
  text-decoration: unset !important;
}
</style>
<style scoped>
.list-installer {
  max-height: 600px;
  overflow-y: auto;
}
</style>

<style >
.marker_item_wrapper {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
  grid-template-areas: "main main main main icons icons";
  grid-gap: 2rem;
  min-height: 88px;
  max-height: 88px;
  overflow: hidden;
}
.marker_main_info {
  grid-area: main;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical !important;
}
.marker_main_info > p {
  overflow: hidden;
}

.marker_icons {
  grid-area: icons;
  display: flex;
  align-items: right;
  justify-content: end;
}
.marker_list_wrapper {
  padding: 0 16px;
  padding-top: 0px;
  padding-right: 16px;
  padding-bottom: 0px;
  padding-left: 16px;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/Markers/List.vue